import { render, staticRenderFns } from "./Recharge.vue?vue&type=template&id=448692c8&scoped=true"
import script from "./Recharge.vue?vue&type=script&lang=ts"
export * from "./Recharge.vue?vue&type=script&lang=ts"
import style0 from "./Recharge.vue?vue&type=style&index=0&id=448692c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448692c8",
  null
  
)

export default component.exports